// @mui material components
import Box from "@mui/material/Box";

export type FormHiddenFieldProps = {
  name: string;
  /** Serialized for FormData (objects should be stringified by the caller). */
  value: string | number | boolean | null | undefined;
};

/**
 * MUI `Box` rendering a native `input[type=hidden]` so dialogs stay theme-consistent
 * while still participating in HTML form submission.
 */
function FormHiddenField({ name, value }: FormHiddenFieldProps) {
  const v = value == null ? "" : String(value);
  return <Box component="input" type="hidden" name={name} value={v} readOnly />;
}

export default FormHiddenField;
